(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ne-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ne-video-slider'))customElements.define('ne-video-slider',class extends HTMLElement{
 connectedCallback(){
 this.abort?.abort();this.abort=new AbortController();const o={signal:this.abort.signal};this.slides=[...this.querySelectorAll('[data-slide]')];if(!this.slides.length)return;this.index=0;this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.reduced.matches;this.manual=false;this.visible=true;this.toggle=this.querySelector('[data-toggle]');this.querySelector('.ne-slider-controls').hidden=false;
 this.slides.forEach(s=>{const v=s.querySelector('video');if(v){v.muted=true;v.controls=false;v.addEventListener('error',()=>{v.hidden=true;},o);}});
 this.querySelector('[data-prev]').hidden=this.slides.length<2;this.querySelector('[data-next]').hidden=this.slides.length<2;
 this.querySelector('[data-prev]').addEventListener('click',()=>this.show(this.index-1,true),o);this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1,true),o);
 this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.manual=false;this.sync();},o);
 this.addEventListener('focusin',()=>clearTimeout(this.timer),o);this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget))this.schedule();},o);
 this.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1),true);}},o);
 document.addEventListener('visibilitychange',()=>this.sync(),o);this.reduced.addEventListener('change',()=>{if(this.reduced.matches){this.paused=true;this.sync();}},o);
 document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.paused=true;this.show(i,true);}},o);
 this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.05});this.observer.observe(this);this.show(0);
 }
 show(index,manual=false){this.index=(index+this.slides.length)%this.slides.length;if(manual)this.manual=true;this.slides.forEach((s,i)=>{const active=i===this.index;s.classList.toggle('is-active',active);s.inert=!active;s.setAttribute('aria-hidden',String(!active));const v=s.querySelector('video');if(v){if(active){v.preload='auto';}else v.pause();}});this.querySelector('[data-count]').textContent=String(this.index+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0');this.sync();}
 sync(){const v=this.slides[this.index]?.querySelector('video');const running=!this.paused&&!document.hidden&&this.visible;if(v){if(running&&this.dataset.autoplay==='true')v.play().catch(()=>{});else v.pause();}this.toggle.textContent=this.paused?this.toggle.dataset.play:this.toggle.dataset.pause;this.schedule();}
 schedule(){clearTimeout(this.timer);if(!this.paused&&!this.manual&&this.visible&&!document.hidden&&this.dataset.rotate==='true'&&this.slides.length>1&&!this.contains(document.activeElement))this.timer=setTimeout(()=>this.show(this.index+1),Number(this.dataset.interval)||10000);}
 disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();this.querySelectorAll('video').forEach(v=>v.pause());}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ne-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ne-product-tabs'))customElements.define('ne-product-tabs',class extends HTMLElement{
connectedCallback(){this.abort?.abort();this.abort=new AbortController();const o={signal:this.abort.signal};const tabs=[...this.querySelectorAll('[data-tab]')];const activate=i=>{tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(n===i));t.tabIndex=n===i?0:-1;});this.querySelectorAll('[data-panel]').forEach((p,n)=>p.hidden=n!==i);};tabs.forEach((t,i)=>{t.addEventListener('click',()=>activate(i),o);t.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();let n=e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;activate(n);tabs[n].focus();}},o);});document.addEventListener('shopify:block:select',e=>{const block=this.querySelector('[data-shopify-editor-block*="'+e.detail.blockId+'"]');if(block?.dataset.tab)activate(Number(block.dataset.tab));},o);}
disconnectedCallback(){this.abort?.abort();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.nm-dropdown[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.nm-dropdown[open],.mobile-menu[open]').forEach((menu) => {
    if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    menu.open = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rv-product-detail'))customElements.define('rv-product-detail',class extends HTMLElement{
 connectedCallback(){this.controller?.abort();this.controller=new AbortController();const select=this.querySelector('select[name="id"]');if(!select)return;const update=()=>{const option=select.selectedOptions[0];if(!option)return;this.querySelector('[data-price]').textContent=option.dataset.price;const compare=this.querySelector('[data-compare]');compare.textContent=option.dataset.compare;compare.hidden=!option.dataset.compare;const button=this.querySelector('[data-purchase]');button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.availableLabel;const quantity=this.querySelector('input[name="quantity"]');quantity.min=option.dataset.min||'1';quantity.step=option.dataset.step||'1';if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');quantity.value=quantity.min;const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);};select.addEventListener('change',update,{signal:this.controller.signal});}
 disconnectedCallback(){this.controller?.abort();}
});

  } catch(e) { console.error(e); }
})();
})();
